<div class="bg-white h-full">
    <!-- Header -->
    <div class="px-4 py-3 pb-0">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
                <div *ngIf="isDangerous" class="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                    <i class="fa-solid fa-triangle-exclamation text-red-600 text-sm"></i>
                </div>
                <h2 class="text-sm font-semibold text-gray-900">{{title}}</h2>
            </div>
            <button (click)="cancel()"
                    class="p-1.5 hover:bg-gray-100 rounded-lg transition-colors">
                <i class="fa-solid fa-xmark text-gray-500 text-sm"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 py-3">
        <div class="text-[13px] text-gray-600">
            {{message}}
        </div>

        <div *ngIf="itemName" class="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div class="flex items-center gap-2">
                <i *ngIf="isDangerous" class="fa-solid fa-triangle-exclamation text-red-500"></i>
                <span class="text-[13px] font-semibold text-red-800">{{itemName}}</span>
            </div>
        </div>

        <div *ngIf="isDangerous" class="mt-4 p-3 bg-red-50 border border-red-300 rounded-lg">
            <p class="text-xs text-red-700 font-medium">
                <i class="fa-solid fa-circle-exclamation mr-1"></i>
                This action is permanent and cannot be undone. All data, configurations, and records associated with this project will be irreversibly deleted.
            </p>
        </div>

        <!-- Confirmation input -->
        <div *ngIf="confirmationText" class="mt-4">
            <label class="block text-xs text-gray-600 mb-1.5">
                To confirm, type <span class="font-bold text-red-700">{{confirmationText}}</span> below:
            </label>
            <input type="text"
                   [(ngModel)]="typedConfirmation"
                   [placeholder]="confirmationText"
                   class="w-full h-9 px-3 text-[13px] border rounded-md outline-none transition-colors"
                   [ngClass]="typedConfirmation.length > 0 && !canConfirm ? 'border-red-300 focus:border-red-500 bg-red-50/50' : 'border-gray-300 focus:border-gray-400'"
                   autocomplete="off"
                   spellcheck="false">
        </div>
    </div>

    <!-- Footer Actions -->
    <div class="px-4 py-3">
        <div class="flex gap-2 justify-end">
            <button (click)="cancel()"
                    type="button"
                    class="h-8 px-4 rounded-md bg-white text-gray-700 text-[13px] transition-colors border border-gray-300 hover:bg-gray-50">
                {{cancelText}}
            </button>

            <button (click)="confirm()"
                    type="button"
                    [disabled]="!canConfirm"
                    [ngClass]="canConfirm ? (isDangerous ? 'bg-red-600 hover:bg-red-700 cursor-pointer' : 'bg-primary hover:bg-primary-700 cursor-pointer') : 'bg-gray-300 cursor-not-allowed'"
                    class="h-8 px-4 rounded-md text-white text-[13px] transition-colors">
                {{confirmText}}
            </button>
        </div>
    </div>
</div>
